<template>
  <div class="footer">
    <div>
      <div class="top">
        <div>
          <div class="about"><span>关于我们</span><span class="cursorPointer c-desc"><a href="http://content.bolanjr.com/intro.html">公司介绍</a></span></div>
        </div>
        <div>
          <div class="connect">联系我们   <div class="cooperation"><span class="cursorPointer zp"><a href="http://content.bolanjr.com/jiaruwomen.html">招聘专页</a></span><span class="cursorPointer hz"><a href="http://content.bolanjr.com/swhezuo.html">商务合作</a></span></div></div>
        </div>
        <div class="gz">
          <div>关注我们</div>
          <div>
            <span class="bl"><img src="../../assets/images/wx.png" alt="loading">博览财经金融服务</span>
            <div><img class="wx-img" src="../../assets/images/blcj.jpg" alt="loading"></div>
          </div>
          <div>
            <span class="fp"><img src="../../assets/images/wx.png" alt="loading">实战复盘</span>
            <div><img class="wx-img" src="../../assets/images/kdkp.jpg" alt="loading"></div>
          </div>
        </div>
      </div>
      <div class="middle">
        <div>版权<span class="ht"> 未经许可，任何人不得复制，转载，或以其他方式使用本网站的内容。</span></div>
        <div>免责<span class="ht"> 本站所有内容仅供参考，学习，不构成任何投资建议，切勿据此进行交易。如因此造成的模拟或实盘资金亏损，风险自负。</span>
        </div>
        <div>注意<span class="ht"> 市场有风险，投资需谨慎。</span></div>
      </div>
      <div class="down"><a href="http://beian.miit.gov.cn" target="_blank" class="ht">鄂ICP备13008883号-6</a><span
        class="ht">Copyright ©
        2019-{{time}} 版权 博览财经</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      time: "",
    };
  },
  mounted() {
    this.nowTime()
  },
  methods : {
    nowTime() {
      let nowDate = new Date();
      let date = {
        // 获取当前年份
        year: nowDate.getFullYear(),
        //获取当前月份
        month: nowDate.getMonth() + 1,
        //获取当前日期
        date: nowDate.getDate(),
      };
      this.time = date.year;
    },
  }
}
</script>

<style scoped>
.footer {
  background-color: #040F27;
  color: #FFFFFF;
  width: 100%;
  margin: 0 auto;
  font-size: 14px;
  position: relative;
}

.footer >div {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 50px 30px;
}

.cursorPointer {
  cursor: pointer;
}

.top {
  display: flex;
  text-align: left;
  margin: 0 0 20px;
  font-size: 14px;
}

.top > div:first-child {
  width: 200px;
}

.top > div:nth-child(2) {
  width: 500px;
}

.about{
  display: flex;
  justify-content: space-between;
}

.c-desc{
  padding-right: 40px;
  color: #959595;
}

.connect{
  padding-left: 160px;
}

.cooperation{
  margin-left: 100px;
  margin-top: -15px;
  color: #959595;
}

.zp{
  display: block;
}

.hz{
  display: block;
  margin-top: 10px;
}

.wx-img{
  width: 96px;
  height: 96px;
}

.gz{
  display: flex;
  justify-content: space-around;
  width: 500px;
}

.bl{
  margin-bottom: 5px;
  margin-left: -20px;
  display: inline-block;
}

.fp{
  margin-bottom: 5px;
  margin-left: 8px;
  display: inline-block;
}

.middle {
  width: 100%;
  text-align: left;
  position: absolute;
  top: 90px;
}

.middle > div {
  margin: 10px 0;
}

.ht{
  color: #959595;
  margin: 0 10px;
}

.down {
  width: 100%;
  text-align: right;
}
.down > span {
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue